import { jsx as _jsx } from "react/jsx-runtime";
import { TranslatableString } from '@rjsf/utils';
import Button from 'react-bootstrap/Button';
import { BsPlus } from '@react-icons/all-files/bs/BsPlus';
export default function AddButton({ uiSchema, registry, ...props }) {
    const { translateString } = registry;
    return (_jsx(Button, { ...props, style: { width: '100%' }, className: `ml-1 ${props.className}`, title: translateString(TranslatableString.AddItemButton), children: _jsx(BsPlus, {}) }));
}
//# sourceMappingURL=AddButton.js.map